
export class BlobUtils
{
    public static CreateBlob(pseudoImage: string): Blob
    {
        const bytes = new TextEncoder().encode(pseudoImage);
        return new Blob([bytes], { type: 'application/octet-stream' });
    }

    public static async BlobToText(blob: Blob | null): Promise<string>
    {
        if (!blob)
            return "";

        return await blob.text();
    }

    public static async ImageFromUrlToBlob(url: string): Promise<Blob>
    {
        const response = await fetch(url);
        if (!response.ok)
        {
            throw new Error(`Failed to fetch image: ${response.status}`);
        }
        return await response.blob();
    }


    public static async HashBlob(blob: Blob): Promise<string>
    {
        const buffer = await blob.arrayBuffer();
        const hash = await crypto.subtle.digest('SHA-256', buffer);

        return [...new Uint8Array(hash)]
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');
    }

    public static async AreBlobsEqual(a: Blob, b: Blob): Promise<boolean>
    {
        if (a.size !== b.size || a.type !== b.type)
            return false;

        const [bufA, bufB] = await Promise.all([
            a.arrayBuffer(),
            b.arrayBuffer()
        ]);

        const viewA = new Uint8Array(bufA);
        const viewB = new Uint8Array(bufB);

        for (let i = 0; i < viewA.length; i++)
        {
            if (viewA[i] !== viewB[i]) return false;
        }

        return true;
    }

    public static Base64ToBlob(base64: string): Blob
    {
        // Remove data URL scheme if present
        let mimeType = "";
        const parts = base64.split(',');
        let b64 = base64;
        if (parts.length > 1)
        {
            b64 = parts[1];
            // Extract mimeType from data URL if possible
            const match = parts[0].match(/^data:([^;]+);base64$/);
            if (match)
            {
                mimeType = match[1];
            }
        }
        if (!mimeType)
        {
            // Fallback to generic image type
            mimeType = "image/png";
        }
        const byteCharacters = atob(b64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++)
        {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    }


    public static async BlobToBase64(blob: Blob): Promise<string>
    {
        return new Promise((resolve, reject) =>
        {
            const reader = new FileReader();

            reader.onload = () =>
            {
                resolve(reader.result as string);
            };

            reader.onerror = () =>
            {
                reject(new Error("Nie udało się przekonwertować Bloba na Base64"));
            };

            reader.readAsDataURL(blob); // <-- tutaj powstaje Base64 z prefixem data:image/...
        });
    }
}
